import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_CAMPAIGN: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 150,
    type: 'action',
    actions: [
      {
        name: 'view',
        iconName: 'view',
      },
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
    alignClass: 'text-start',
  },
  // {
  //   dataKey: 'id',
  //   label: 'ID',
  //   width: 100,
  //   type: 'number',
  // },
  {
    dataKey: 'srno',
    label: '#',
    width: 100,
    type: 'number',
  },
  {
    dataKey: 'campaignName',
    label: 'Campaign Name',
    width: 200,
    type: 'text',
  },
  // { dataKey: 'description', label: 'Description', width: 250, type: 'text' },
  // {
  //   dataKey: 'filterName',
  //   label: 'Filter Name',
  //   width: 150,
  //   type: 'text',
  // },
  {
    dataKey: 'totalAmount',
    label: 'Targeted Amount',
    width: 200,
    type: 'currency',
  },
  {
    dataKey: 'patientCount',
    label: 'Targeted Patients',
    width: 200,
    type: 'number',
  },
  {
    dataKey: 'totalCollectedAmount',
    label: 'Collected Amount',
    width: 200,
    type: 'currency',
  },
  {
    dataKey: 'uniquePatientCount',
    label: 'Patients Paid',
    width: 200,
    type: 'number',
  },
  {
    dataKey: 'templateName',
    label: 'Template Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'paymentPromotion',
    label: 'Promotion',
    width: 100,
    type: 'boolean',
  },
  {
    dataKey: 'startDate',
    label: 'Start Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'endDate',
    label: 'End Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'frequency',
    label: 'Frequency',
    width: 150,
    type: 'text',
  },
  {
    dataKey: 'isActive',
    label: 'Status',
    width: 150,
    type: 'status',
  },
];
